export const fontWeight = {
    light: 'lighter',
    medium: 'normal',
    semiBold: '600',
    bold: 'bold',
};

export const textDecorations = {
    lineThrough: 'line-through',
    underline: 'underline',
    none: 'none',
};

export const textTransformations = {
    capitalize: 'capitalize',
    uppercase: 'uppercase',
    lowercase: 'lowercase',
    none: 'none',
};

export const textAligns = {
    left: 'left',
    center: 'center',
    right: 'right',
};

export const buttonShape = {
    rounded: 'rounded',
    square: 'square',
    oval: 'oval',
};

export const buttonType = {
    default: 'default',
    outline: 'outline',
    text: 'text',
};

export const objectPostion = {
    bottom: 'bottom',
    top: 'top',
};

export const directions = {
    up: 'up',
    down: 'down',
    left: 'left',
    right: 'right',
};

export const flexDirections = {
    up: 'column-reverse',
    down: 'column',
    left: 'row-reverse',
    right: 'row',
};

export const objectAlignment = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
};

export const listStyleType = {
    circle: 'circle',
    decimal: 'decimal',
    disc: 'disc',
    disclosureClosed: 'disclosure-closed',
    square: 'square',
    none: 'none',
};

export const sidebarPostions = {
    right: '--right',
    left: '--left',
};

export const scoreTypes = {
    number: 'number',
    text: 'text',
};
